import { useNavigate } from 'react-router-dom';
import '../styles/landing.css';

const LINKS = [
  { label: 'Contact', path: '/contact' },
  { label: 'Blog', path: '/blog' },
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Service', path: '/terms' },
];

export default function LandingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="landing-footer">
      <div className="landing-footer-content">
        <div className="landing-footer-links">
          {LINKS.map(({ label, path }) => (
            <button key={path} onClick={() => navigate(path)} className="landing-footer-link">
              {label}
            </button>
          ))}
        </div>
        <div className="landing-footer-copyright">
          © {new Date().getFullYear()} CrewCast. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
